export let SIZES = /*#__PURE__*/function (SIZES) {
  SIZES["SMALL"] = "small";
  SIZES["NORMAL"] = "normal";
  return SIZES;
}({});
export let TYPES = /*#__PURE__*/function (TYPES) {
  TYPES["COLORED"] = "colored";
  TYPES["NEUTRAL"] = "neutral";
  return TYPES;
}({});